jQuery.fn.extend({
  isInputValid: function() {
      var validity, readOnly, disabled;
      readOnly = this.prop("readonly");
      disabled = this.prop("disabled");
      this.prop("readonly", false);
      this.prop("disabled", false);
      validity = this[0].checkValidity();
      this.prop("readonly", readOnly);
      this.prop("disabled", disabled);
      return validity;
    }
});
